/* eslint-disable no-console */
/* eslint-disable object-shorthand */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/order */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/keyword-spacing */
import React, { useEffect, useState } from "react";

import { useNavigate, useSearchParams } from "react-router-dom";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";

import SompoTextField from "../../component/textField/SompoTextField";
import { PasswordValues } from "../../component/changePassword/ChangePasswordDialog";
import { useScreenSize } from "../../component/Theme";
import Environments from "../../Environments";
import { showErrorMessage, openInformationDialog } from "../../logic/hook/useDialogStateHelper";
import ChangePasswordService from "../../logic/api/ChangePasswordService";

const ChangePassword = () => {
    const navigate = useNavigate();
    const handleCancel = () => {
        navigate("/");
    };

    const [searchParams] = useSearchParams();
    const authKey = searchParams.get("authKey") || "";

    const service = new ChangePasswordService();

    const theme = useTheme();
    const { desktop } = useScreenSize();
    const [password, setPassword] = useState<PasswordValues>({
        password: "",
        rePassword: "",
    });
    const [changePasswordSuccess, setChangePasswordSuccess] = useState(false);

    const handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword({ ...password, [event.target.name]: event.target.value });
    };

    /**
     * バリデーションチェック
     * @returns true: バリデーションエラー, false: エラーなし
     */
    const validation = () => {
        if (password.password !== password.rePassword) {
            showErrorMessage({ message: "新しいパスワード、新しいパスワード(再入力)が一致していません。" });
            return true;
        }
        return false;
    };

    // 「変更」ボタン押下時（新パスワード登録）
    const changePassword = () => {
        if (validation()) return;
        if (!Environments.MOCK) {
            const fetch = async () => {
                await service.changePassword(
                    {
                        password: password.password,
                        rePassword: password.rePassword,
                        authKey: authKey,
                    },
                    () => setChangePasswordSuccess(true),
                    (error: any) => {
                        if (error.message === "ERROR_PASSWORD_POLICY") {
                            showErrorMessage({
                                message: "このパスワードはパスワードポリシー違反です。パスワードを変更してください",
                                error,
                            });
                        } else {
                            console.error(error);
                            const errorMessage = String(error).replace("Error: ", "");
                            showErrorMessage({ message: `パスワードの変更に失敗しました。<br/> ${errorMessage}`, error });
                        }
                    }
                );
            };
            void fetch();
        } else {
            setChangePasswordSuccess(true);
        }
    };

    useEffect(() => {
        if (changePasswordSuccess) {
            openInformationDialog({
                message: "パスワードを変更しました。\nログイン画面を表示します。",
                resolve: () => {
                    setChangePasswordSuccess(false);
                    navigate("/");
                },
            });
        }
    }, [changePasswordSuccess]);

    const formLabelStyle = {
        fontWeight: 700,
        fontSize: "14px",
        letterSpacing: "1px",
        paddingLeft: "5px",
    };

    const changePasswordButtonActive = password.password !== "" && password.rePassword !== "";

    return (
        <>
            <Grid
                container
                direction="column"
                alignItems="center"
                flexWrap="nowrap"
                sx={{
                    width: "100%",
                    height: "100%",
                    p: 5,
                    overflowY: desktop ? "none" : "scroll", // スマホ横向き対応
                    bgcolor: "background.paper",
                    outline: "none",
                }}
            >
                <Grid
                    item
                    sx={{
                        width: "100%",
                        textAlign: desktop ? "left" : "center",
                        mb: 3,
                    }}
                >
                    <Typography
                        variant="h5"
                        sx={{
                            color: theme.palette.primary.main,
                        }}
                    >
                        {"SOMPO Learning Hub"}
                    </Typography>
                </Grid>
                <Grid item sx={{ pt: 3, pb: 3 }}>
                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: "20px",
                        }}
                    >
                        パスワード変更
                    </Typography>
                </Grid>
                <Grid item sx={{ width: desktop ? "65%" : "100%" }}>
                    <Grid container direction={"column"}>
                        <Grid item>
                            <Typography>パスワードに使用できる文字種、文字数は以下のとおりです。</Typography>
                        </Grid>
                        <Grid item container direction={"row"} flexWrap={"nowrap"}>
                            <Grid item sx={{ minWidth: "80px", maxWidth: "80px" }}>
                                <Typography sx={{ fontWeight: "bold", textIndent: "16px" }}>文字種：</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ fontWeight: "bold" }}>
                                    半角英大文字・英小文字・数字・半角ハイフン、半角アンダーバー、記号から3種を組み合わせて作成
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item container direction={"row"} flexWrap={"nowrap"}>
                            <Grid item sx={{ minWidth: "80px", maxWidth: "80px" }}>
                                <Typography sx={{ fontWeight: "bold" }}>&nbsp;</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ fontWeight: "bold" }}>{"※使用可能記号は(.@`!#$%&'*+/=?^{|})です。"}</Typography>
                            </Grid>
                        </Grid>
                        <Grid item container direction={"row"} flexWrap={"nowrap"}>
                            <Grid item sx={{ minWidth: "80px", maxWidth: "80px" }}>
                                <Typography sx={{ fontWeight: "bold", textIndent: "16px" }}>文字数：</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ fontWeight: "bold" }}>8文字以上16文字以内</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <SompoTextField
                        fullWidth
                        label={<Typography sx={formLabelStyle}>新しいパスワード</Typography>}
                        onChange={handleChangePassword}
                        type="password"
                        name="password"
                        value={password.password}
                        sx={{ size: { sm: "small", md: "medium" }, m: 1 }}
                    />
                    <SompoTextField
                        fullWidth
                        label={<Typography sx={formLabelStyle}>新しいパスワード(再入力)</Typography>}
                        onChange={handleChangePassword}
                        type="password"
                        name="rePassword"
                        value={password.rePassword}
                        sx={{ size: { sm: "small", md: "medium" }, m: 1 }}
                    />
                </Grid>
                <Grid item>
                    <Button
                        disabled={!changePasswordButtonActive}
                        sx={{
                            backgroundColor: changePasswordButtonActive ? theme.palette.primary.main : "#ddd",
                            height: { sm: 40, md: 45 },
                            transition: "all 0.2s ease-in-out",
                            "&: hover": {
                                backgroundColor: theme.palette.primary.main,
                                opacity: 0.7,
                            },
                        }}
                        onClick={changePassword}
                    >
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: "14px",
                                letterSpacing: "1px",
                                ml: 3,
                                mr: 3,
                                color: changePasswordButtonActive ? "#fefefe" : "#F3F3F4",
                            }}
                        >
                            変更
                        </Typography>
                    </Button>

                    <Button
                        sx={{
                            height: { sm: 40, md: 45 },
                            marginLeft: "10px",
                            border: "1px solid #ddd",
                        }}
                        onClick={handleCancel}
                    >
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: "14px",
                                letterSpacing: "1px",
                                color: "#333",
                            }}
                        >
                            キャンセル
                        </Typography>
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

export default ChangePassword;
